export default function useCoding() {
  const router = useRouter()
  const route = useRoute()
  const { t } = useI18n()

  const codingLanguages: Record<CodingLanguage, {
    color: CodingLanguageColor
    icon: string
    label: string
    sdk: string
  }> = {
    csharp: {
      color: 'purple',
      icon: getIcon('csharp'),
      label: t('coding.languages.csharp'),
      sdk: '',
    },
    go: {
      color: 'cyan',
      icon: getIcon('go'),
      label: t('coding.languages.go'),
      sdk: 'https://github.com/thecompaniesapi/sdk-go',
    },
    java: {
      color: 'orange',
      icon: getIcon('java'),
      label: t('coding.languages.java'),
      sdk: '',
    },
    javascript: {
      color: 'yellow',
      icon: getIcon('javascript'),
      label: t('coding.languages.javascript'),
      sdk: 'https://github.com/thecompaniesapi/sdk-typescript',
    },
    php: {
      color: 'indigo',
      icon: getIcon('php'),
      label: t('coding.languages.php'),
      sdk: 'https://github.com/thecompaniesapi/sdk-php',
    },
    python: {
      color: 'blue',
      icon: getIcon('python'),
      label: t('coding.languages.python'),
      sdk: 'https://github.com/thecompaniesapi/sdk-python',
    },
    ruby: {
      color: 'red',
      icon: getIcon('ruby'),
      label: t('coding.languages.ruby'),
      sdk: 'https://github.com/thecompaniesapi/sdk-ruby',
    },
    rust: {
      color: 'amber',
      icon: getIcon('rust'),
      label: t('coding.languages.rust'),
      sdk: '',
    },
  }

  const integrations: Record<IntegrationName, {
    color: IntegrationColor
    icon: string
    label: string
    url: string
  }> = {
    email: {
      color: 'blue',
      icon: getIcon('email'),
      label: t('coding.integrations.email'),
      url: '',
    },
    make: {
      color: 'purple',
      icon: getIcon('make'),
      label: t('coding.integrations.make'),
      url: '',
    },
    mcp: {
      color: 'black',
      icon: getIcon('mcp'),
      label: t('coding.integrations.mcp'),
      url: '',
    },
    n8n: {
      color: 'red',
      icon: getIcon('n8n'),
      label: t('coding.integrations.n8n'),
      url: '',
    },
    slack: {
      color: 'red',
      icon: getIcon('slack'),
      label: t('coding.integrations.slack'),
      url: '',
    },
    webhook: {
      color: 'yellow',
      icon: getIcon('webhook'),
      label: t('coding.integrations.webhook'),
      url: '',
    },
    zapier: {
      color: 'orange',
      icon: getIcon('zapier'),
      label: t('coding.integrations.zapier'),
      url: '',
    },
  }

  // Methods
  const getPreferredCodingLanguage = (): CodingLanguage | undefined => {
    if (import.meta.client) {
      return localStorage.getItem('coding-language') as CodingLanguage
    }
  }

  const saveCodingLanguage = (language: CodingLanguage) => {
    if (import.meta.client && language) {
      localStorage.setItem('coding-language', language)

      router.replace({
        name: route.name,
        params: route.params,
        query: {
          ...route.query,
          language,
        },
      })
    }
  }

  return {
    codingLanguages,
    getPreferredCodingLanguage,
    integrations,
    saveCodingLanguage,
  }
}
